<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="subtitle" />
    <!-- Main Content-->
    <main>
        <div class="container px-4 px-lg-5">
            <div class="row gx-4 gx-lg-5 justify-content-center">
                <div class="col-md-10 col-lg-8 col-xl-8">
                    <h2>QQ:3071218006</h2>
                </div>
            </div>
        </div>
    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
const title = "联系方式"
const subtitle = "欢迎来找我玩！"
</script>
<style scoped>
h2{
    text-align: center;
    margin-bottom: 2rem;
}
</style>